import { mdiChevronLeft } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '.'

const ChevronLeft = (props: IconProps) => (
    <Icon
        data-testid="IconButton__BackButton"
        path={mdiChevronLeft}
        size={1}
        {...props}
    />
)

export default ChevronLeft
